import React, { useCallback, useEffect, useState } from 'react'

import { Box } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { CuratedBoxLayout } from '@features/curated-box-carousel'

import { showDetailRecipe } from 'routes/Menu/actions/menuRecipeDetails'
import { useStock } from 'routes/Menu/domains/basket'
import { getNumPortions } from 'selectors/basket'
import { getRecipes } from 'selectors/root'

import { getCuratedBoxes } from '../../selectors/menuService'
import { DetailOverlay } from '../Detail'

const handleOnClickForCuratedBox = () => 'handleOnClickForCuratedBox'

export const CuratedBoxes = () => {
  const { isRecipeOutOfStock } = useStock()
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false)

  useEffect(() => {
    setShouldShowOverlay(true)
  }, [])

  const dispatch = useDispatch()

  const handleShowRecipeDetails = useCallback(
    (...args) => dispatch(showDetailRecipe(...args)),
    [dispatch],
  )

  return (
    <Box>
      <>
        <CuratedBoxLayout
          handleShowRecipeDetails={handleShowRecipeDetails}
          handleOnClickForCuratedBox={handleOnClickForCuratedBox}
          curatedBoxesMethods={{
            getRecipeStock: { isRecipeOutOfStock },
            getRecipes,
            getCuratedBoxes,
            getNumPortions,
          }}
        />
        <DetailOverlay showOverlay={shouldShowOverlay} />
      </>
    </Box>
  )
}
